export const formatToYesOrNo = (data: boolean, formatMessage: ({ id }: { id: string }) => string) => {
    if (data !== undefined) {
        return data === true ? formatMessage({ id: 'commonYes' }) : formatMessage({ id: 'commonNo' });
    } else {
        return '';
    }
};
